// extracted by mini-css-extract-plugin
export default {"table":"Gates_table__R2Asz","checkbox":"Gates_checkbox__5LOkN"};